module.exports = __webpack_public_path__ + "static/media/star2.d1630d53.svg";